import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock, AlertCircle, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { setErr("Heslo musí mať aspoň 6 znakov"); return; }
    if (pw !== pw2)  { setErr("Heslá sa nezhodujú"); return; }
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e2) { setErr(e2.response?.data?.detail || "Chyba"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-[var(--wb-surface)] border border-zinc-800 p-8" data-testid="reset-password-page">
        <div className="flex items-center gap-2 mb-8">
          <img src="/tigik-logo.png" alt="Tigik" className="w-10 h-10 object-cover border border-gold-600/40" />
          <span className="font-display font-black text-xl">TIGIK</span>
        </div>

        {!token ? (
          <div className="border-l-2 border-red-500 bg-red-500/5 p-5">
            <AlertCircle className="w-8 h-8 text-red-500 mb-3" />
            <h2 className="font-display font-bold text-lg">Neplatný odkaz</h2>
            <p className="text-sm text-zinc-400 mt-1">Token chýba. Požiadaj o nový reset link.</p>
            <Link to="/forgot-password" className="wb-btn-ghost inline-block mt-4 px-4 py-2 text-xs">Požiadať o reset</Link>
          </div>
        ) : done ? (
          <div data-testid="reset-done" className="border-l-2 border-green-500 bg-green-500/5 p-5">
            <CheckCircle2 className="w-8 h-8 text-green-500 mb-3" />
            <h2 className="font-display font-bold text-lg">Heslo zmenené ✅</h2>
            <p className="text-sm text-zinc-400 mt-1">Presmerujeme ťa na prihlásenie…</p>
          </div>
        ) : (
          <>
            <h1 className="font-display font-bold text-3xl mb-1">Nové heslo</h1>
            <p className="text-sm text-zinc-500 mb-8 font-mono uppercase tracking-wider">→ set new password</p>
            <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
              <div>
                <label className="block text-xs font-mono uppercase tracking-wider text-zinc-500 mb-1">Nové heslo</label>
                <input data-testid="reset-pw1" type="password" required minLength={6} value={pw}
                  onChange={(e) => setPw(e.target.value)} className="wb-input w-full px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-xs font-mono uppercase tracking-wider text-zinc-500 mb-1">Potvrď heslo</label>
                <input data-testid="reset-pw2" type="password" required minLength={6} value={pw2}
                  onChange={(e) => setPw2(e.target.value)} className="wb-input w-full px-3 py-2 text-sm" />
              </div>
              {err && (
                <div className="flex items-center gap-2 p-2 border border-red-900 bg-red-950/30 text-red-400 text-sm">
                  <AlertCircle className="w-4 h-4" /> {err}
                </div>
              )}
              <button data-testid="reset-submit" type="submit" disabled={busy}
                className="wb-btn-primary w-full py-3 text-sm disabled:opacity-50 inline-flex items-center justify-center gap-2">
                <Lock className="w-4 h-4" /> Nastaviť nové heslo
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
